import React, { useState } from "react";

import userSecurityService
    from "../services/userSecurityService";

import { validatePassword }
    from "../utils/passwordValidator";

const UserPasswordTab = ({

    user,

    loadPermissions

}) => {

        const [changePassword, setChangePassword] = useState({

        new_password: "",

        confirm_password: ""

    });

    const [showNewPassword, setShowNewPassword] = useState(false);

    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [loading, setLoading] = useState(false);

        const validateChangePassword = () => {

            if (!changePassword.new_password.trim()) {

                alert("New Password is required.");

                return false;

            }

            if (!changePassword.confirm_password.trim()) {

                alert("Confirm Password is required.");

                return false;

            }

            const errors = validatePassword(
                changePassword.new_password
            );

            if (errors.length) {

                alert(errors[0]);

                return false;

            }

            if (

                changePassword.new_password !==

                changePassword.confirm_password

            ) {

                alert("Passwords do not match.");

                return false;

            }

            return true;

        };
        const handleChangePassword = async () => {

        if (!validateChangePassword()) {

            return;

        }

        try {

            setLoading(true);

            await userSecurityService.changePassword(

                user.user_access_mapping_id,

                {

                    new_password:

                        changePassword.new_password

                }

            );

            alert(

                "Password changed successfully."

            );

            setChangePassword({

                new_password: "",

                confirm_password: ""

            });

        }

        catch (err) {

            console.error(err);

            alert(

                err?.response?.data?.message ||

                "Failed to change password."

            );

        }

        finally {

            setLoading(false);

        }

    };


    return (

        <div className="row">

            <div className="col-lg-6">

                <div className="card shadow-sm">

                    <div className="card-header">

                        Change Password

                    </div>

                    <div className="card-body">

                        <div className="mb-3">

                            <label className="form-label">

                                New Password

                            </label>

                            <div className="input-group">

                                <input

                                    type={
                                        showNewPassword
                                            ? "text"
                                            : "password"
                                    }

                                    className="form-control"

                                    value={changePassword.new_password}

                                    onChange={(e) =>

                                        setChangePassword({

                                            ...changePassword,

                                            new_password: e.target.value

                                        })

                                    }

                                    autoComplete="new-password"

                                />

                                <button

                                    type="button"

                                    className="btn btn-outline-secondary"

                                    onClick={() =>

                                        setShowNewPassword(

                                            !showNewPassword

                                        )

                                    }

                                >

                                    <i
                                        className={`bi ${
                                            showNewPassword
                                                ? "bi-eye-slash"
                                                : "bi-eye"
                                        }`}
                                    />

                                </button>

                            </div>

                        </div>

                        <div className="mb-3">

                            <label className="form-label">

                                Confirm Password

                            </label>

                            <div className="input-group">

                                <input

                                    type={
                                        showConfirmPassword
                                            ? "text"
                                            : "password"
                                    }

                                    className="form-control"

                                    value={changePassword.confirm_password}

                                    onChange={(e) =>

                                        setChangePassword({

                                            ...changePassword,

                                            confirm_password: e.target.value

                                        })

                                    }

                                    autoComplete="new-password"

                                />

                                <button

                                    type="button"

                                    className="btn btn-outline-secondary"

                                    onClick={() =>

                                        setShowConfirmPassword(

                                            !showConfirmPassword

                                        )

                                    }

                                >

                                    <i
                                        className={`bi ${
                                            showConfirmPassword
                                                ? "bi-eye-slash"
                                                : "bi-eye"
                                        }`}
                                    />

                                </button>

                            </div>

                        </div>

                        <div className="d-flex justify-content-end">

                            <button

                                className="btn btn-primary"

                                disabled={loading}

                                onClick={handleChangePassword}

                            >

                                {

                                    loading

                                        ? (

                                            <>

                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                />

                                                Changing...

                                            </>

                                        )

                                        : (

                                            <>

                                                <i className="bi bi-key me-2"></i>

                                                Change Password

                                            </>

                                        )

                                }

                            </button>

                        </div>

                    </div>

                </div>

            </div>

            <div className="col-lg-6">

                <div className="card shadow-sm">

                    <div className="card-header">

                        Reset Password

                    </div>

                    <div className="card-body">

                        Coming next...

                    </div>

                </div>

            </div>

        </div>

    );

};

export default UserPasswordTab;